export const SET_THEME = 'SET_THEME'

export function setTheme(value) {
  return {
    type: SET_THEME,
    payload: value,
  }
}
